import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, Heart, X, ArrowRight } from 'lucide-react';
import pb from '../lib/pocketbase';
import { useCart } from '../context/CartContext';
import { useFavorites } from '../context/FavoritesContext';
import { useSettings } from '../context/SettingsContext';
import './Creations.css';

const Creations = () => {
    const [creations, setCreations] = useState([]);
    const [selectedPastry, setSelectedPastry] = useState(null);
    const { addToCart } = useCart();
    const { toggleFavorite, isFavorite } = useFavorites();
    const { settings } = useSettings();

    useEffect(() => {
        const fetchCreations = async () => {
            try {
                // Fetch the 3 most recent patisseries
                const records = await pb.collection('patisseries').getList(1, 3, {
                    sort: '-created',
                    filter: 'estSouvenir = false'
                });

                const mappedPastries = records.items.map(record => ({
                    id: record.id,
                    name: record.nom,
                    description: record.description,
                    prix: record.prix,
                    image: record.photo ? pb.files.getURL(record, record.photo) : null,
                    available: record.disponible,
                    stock: record.stock || 0,
                    showStock: record.afficherStock,
                    lowStockThreshold: record.lowStockThreshold || 5
                }));

                setCreations(mappedPastries);
            } catch (err) {
                console.error("Erreur chargement créations:", err);
            }
        };

        fetchCreations();
    }, []);

    const openModal = (pastry) => {
        setSelectedPastry(pastry);
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setSelectedPastry(null);
        document.body.style.overflow = 'auto';
    };

    return (
        <div className="container" style={{ paddingTop: '100px', paddingBottom: '100px' }}>
            <h2 className="text-center animate-fade-in" style={{ marginBottom: '60px' }}>Créations du moment</h2>

            <div className="bento-grid">
                {creations.map((item) => (
                    <div key={item.id} className="creation-card" onClick={() => openModal(item)}>
                        <img src={item.image || '/images/logo_real.jpg'} alt={item.name} className="creation-image" />
                        <div className="creation-overlay">
                            <h3 className="creation-title">{item.name}</h3>
                            <p className="creation-desc" style={{ display: '-webkit-box', WebkitLineClamp: '2', WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{item.description}</p>
                        </div>
                    </div>
                ))}
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '60px', flexWrap: 'wrap' }}>
                <Link to="/notre-carte" className="btn btn-outline" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    Nos Pâtisseries <ArrowRight size={18} />
                </Link>
                <Link to="/gateaux" className="btn" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    Nos Gâteaux <ArrowRight size={18} />
                </Link>
            </div>

            {/* Cake Modal */}
            {selectedPastry && (
                <div className="cake-modal-overlay" onClick={closeModal} style={{ zIndex: 99999 }}>
                    <div className="cake-modal-content" onClick={e => e.stopPropagation()}>
                        <button className="cake-modal-close" onClick={closeModal}>
                            <X size={24} />
                        </button>
                        <div className="cake-modal-split">
                            <div className="cake-modal-image-side">
                                <img src={selectedPastry.image || '/images/logo_real.jpg'} alt={selectedPastry.name} />
                            </div>
                            <div className="cake-modal-info-side">
                                <h2>{selectedPastry.name}</h2>
                                <div className="modal-price">
                                    {selectedPastry.prix ? `${selectedPastry.prix} €` : 'Prix sur demande'}
                                </div>
                                <div className="modal-divider"></div>
                                <p className="modal-description">{selectedPastry.description}</p>

                                <div className="modal-actions">
                                    {selectedPastry.available && selectedPastry.stock > 0 ? (
                                        <div style={{ width: '100%' }}>
                                            {settings.isClickCollectDisabled ? (
                                                <button
                                                    className="btn btn-outline"
                                                    onClick={() => toggleFavorite(selectedPastry)}
                                                    style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}
                                                >
                                                    <Heart size={20} fill={isFavorite(selectedPastry.id) ? 'var(--color-brown)' : 'none'} color="var(--color-brown)" />
                                                    {isFavorite(selectedPastry.id) ? 'Retirer des favoris' : 'Ajouter aux favoris'}
                                                </button>
                                            ) : (
                                                <button
                                                    className="btn"
                                                    onClick={() => {
                                                        addToCart(selectedPastry);
                                                        closeModal();
                                                    }}
                                                    style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}
                                                >
                                                    <ShoppingBag size={20} />
                                                    Ajouter au panier
                                                </button>
                                            )}
                                            {selectedPastry.showStock && (
                                                <p style={{ textAlign: 'center', marginTop: '10px', color: selectedPastry.stock <= selectedPastry.lowStockThreshold ? '#e67e22' : '#27ae60', fontWeight: '500' }}>
                                                    {selectedPastry.stock <= selectedPastry.lowStockThreshold
                                                        ? `⚡ Attention, plus que ${selectedPastry.stock} en stock !`
                                                        : `Disponibilité : ${selectedPastry.stock} en stock`}
                                                </p>
                                            )}
                                        </div>
                                    ) : (
                                        <button
                                            className="btn"
                                            disabled
                                            style={{ width: '100%', background: '#ccc', cursor: 'not-allowed' }}
                                        >
                                            Épuisé
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Creations;
